"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkCard = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Chip_1 = __importDefault(require("@opsbase/web-chips/Chip"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = statusColor => ({
    root: {
        overflow: 'hidden',
        position: 'relative',
        height: 'auto',
        borderTop: `1px solid ${statusColor.light} !important`,
        borderBottom: `1px solid ${statusColor.light} !important`,
        borderLeft: `4px solid ${statusColor.main} !important`,
        backgroundColor: lib_palette_1.default.White.main,
        padding: '4px 0 8px 12px',
        transition: 'border 0.2s, background 0.2s',
        '&:hover': {
            borderTop: `1px solid ${lib_palette_1.default.primary.light} !important`,
            borderBottom: `1px solid ${lib_palette_1.default.primary.light} !important`,
            borderLeft: `4px solid ${lib_palette_1.default.primary.main} !important`,
            backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        },
    },
    watermark: {
        pointerEvents: 'none',
        position: 'absolute',
        right: -24,
        bottom: -24,
        opacity: 0.1,
        zIndex: 9,
    },
});
function LinkCard(props) {
    const { title, description, tags = [], watermark: Watermark, watermarkColor = lib_palette_1.default.GreyBlue, statusColor = lib_palette_1.default.GreyBlue, onClick, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [statusColor]);
    const validTags = tags.filter(t => !!t);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true, classes: { root: myCss.root }, onClick: onClick },
        !!Watermark && (react_1.default.createElement(Watermark, { size: 140, color: watermarkColor, className: myCss.watermark })),
        react_1.default.createElement(Text_1.default, { variant: "h1" }, title),
        !!description && react_1.default.createElement(Text_1.default, { variant: "body" }, description),
        !!(validTags === null || validTags === void 0 ? void 0 : validTags.length) && (react_1.default.createElement(Horizontal_1.default, { gutter: true, justify: "flex-start" }, validTags.map((tag, idx) => (react_1.default.createElement(Chip_1.default, { key: 'tag' + idx, small: true, color: lib_palette_1.default.Grey, label: tag })))))));
}
exports.LinkCard = LinkCard;
exports.default = LinkCard;
